import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>Mr. Tyrone Johnson</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>Engineering is one of the brightest educational fields that have a real-world physical impact on the lives of people. It was this passion that pushed Mr. Tyrone Johnson into the field of Engineering, helping improve everyday life experiences for people. An expert in engineering technology, systems integration, and engineering software implementation, Tyrone has over a decade of experience in overseeing technological developments in the field of engineering. We’ve invited Mr. Johnson as our guest for S02 E03 of Technology for Change, to discuss “The Future of Engineering Technologies” with Tekrevol’s partner and host of Technology For Change S2, Daniel Burgess</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;